<div class="c-modal-dialog modal-container">
  <div class="content-wrapper">
    <p class="c-text-lg">Couldn't save the submitted designations as someone modified the data on this screen while you were entering breakdowns. Please refresh the page to load latest information.</p>
  </div>
  <div class="btn-wrapper">
    <button type="button" class="c-btn rounded c-text-lg" (click)="closeModal()">Cancel</button>
    <button type="button" class="c-btn c-btn-primary rounded c-text-lg" (click)="reloadPage()">Refresh</button>
  </div>
</div>